import React, { useState } from 'react';
import { Grid, Typography, Button, Pagination, FormControl, InputLabel, Select, MenuItem, Chip, Box, IconButton, Menu } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import SearchIcon from '@mui/icons-material/Search';
import { EditarDocumento } from './EditarDocumento';
import { useNavigate, useLocation } from 'react-router-dom';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import { CrearDocumento } from './CrearDocumento';

export const Documentos = () => {

    const [menuAnchor, setMenuAnchor] = useState(null);
    const [menuRowId, setMenuRowId] = useState(null);
    const [editRowId, setEditRowId] = useState(null);
    const [openCreate, setOpenCreate] = useState(false);


    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path) => location.pathname === path;



    const handleOpenMenu = (event, rowId) => {
        setMenuAnchor(event.currentTarget);
        setMenuRowId(rowId);
    };

    const handleCloseMenu = () => {
        setMenuAnchor(null);
        setMenuRowId(null);
    };

    const handleOpenEdit = () => {
        setEditRowId(menuRowId);
        handleCloseMenu();
    };



    return (
        <Grid container direction="column" size={{ xs: 12 }}>

            {/* HEADER */}
            <Grid item size={{ xs: 12 }}>
                <SubHeader titulo="Documentación" />
            </Grid>

            {/* TABS */}
            <Grid
                container
                spacing={2}
                sx={{ px: 2, pb: 2 }}
                alignItems="center"
            >
                <Button
                    variant="text"
                    onClick={() => navigate('/personas')}
                    sx={{
                        fontWeight: isActive('/personas') ? 600 : 400,
                        borderBottom: isActive('/personas')
                            ? '2px solid'
                            : '2px solid transparent',
                        borderRadius: 0
                    }}
                >
                    Personas
                </Button>

                <Button
                    variant="text"
                    onClick={() => navigate('/carpetas')}
                    sx={{
                        fontWeight: isActive('/carpetas') ? 600 : 400,
                        borderBottom: isActive('/carpetas')
                            ? '2px solid'
                            : '2px solid transparent',
                        borderRadius: 0
                    }}
                >
                    Carpetas
                </Button>

                <Button
                    variant="text"
                    onClick={() => navigate('/documentacion')}
                    sx={{
                        fontWeight: isActive('/documentacion') ? 600 : 400,
                        borderBottom: isActive('/documentacion')
                            ? '2px solid'
                            : '2px solid transparent',
                        borderRadius: 0
                    }}
                >
                    Documentos
                </Button>
            </Grid>


            {/* ACCIONES */}
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ px: 2, pb: 2 }}
                gap={2}
            >
                <Grid container spacing={1} size={{ xs: 12, md: 'auto' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: 1,
                            px: 1.5,
                            py: 0.5,
                            width: { xs: '100%', md: 260 }
                        }}
                    >
                    </Box>
                </Grid>

                <Grid container spacing={1} size={{ xs: 12, md: 'auto' }}>
                    <Button variant="outlined" startIcon={<FilterAltIcon />}>Filtros</Button>
                    <Button variant="outlined" startIcon={<FileDownloadIcon />}>Exportar</Button>
                    <Button variant="outlined" startIcon={<ViewColumnIcon />}>Columnas</Button>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => setOpenCreate(true)}
                    >
                        Crear
                    </Button>
                </Grid>
            </Grid>

            {/* SCROLL MOBILE */}
            <Grid sx={{ width: '100%', overflowX: 'auto' }}>
                <Grid
                    container
                    direction="column"
                    sx={{ minWidth: { xs: 900, md: 1200 } }}
                >

                    {/* HEADER TABLA */}
                    <Grid
                        container
                        alignItems="center"
                        sx={{
                            px: 2,
                            py: 1,
                            bgcolor: 'grey.100',
                            borderTop: '1px solid',
                            borderBottom: '1px solid',
                            borderColor: 'divider'
                        }}
                    >
                        <Grid item size={{ xs: 0.5 }} />
                        <Grid item size={{ xs: 3.2 }}>Nombre</Grid>
                        <Grid item size={{ xs: 1.6 }}>Empresas/Clientes</Grid>
                        <Grid item size={{ xs: 1.3 }}>Tipo</Grid>
                        <Grid item size={{ xs: 1.8 }}>Tipo de firma</Grid>
                        <Grid item size={{ xs: 1.1 }}>Privacidad</Grid>
                        <Grid item size={{ xs: 1.1 }}>Entidades</Grid>
                        <Grid item size={{ xs: 1.4 }}>Añadir por defecto</Grid>
                    </Grid>

                    {/* FILAS */}
                    {[1, 2].map(row => (
                        <Grid
                            key={row}
                            container
                            alignItems="center"
                            sx={{
                                px: 2,
                                py: 1,
                                borderBottom: '1px solid',
                                borderColor: 'divider',
                                '&:hover': { bgcolor: 'action.hover' }
                            }}
                        >
                            <Grid item size={{ xs: 0.5 }}>
                                <Grid item size={{ xs: 0.5 }}>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => handleOpenMenu(e, row)}
                                    >
                                        <MoreVertIcon fontSize="small" />
                                    </IconButton>
                                    <Menu
                                        anchorEl={menuAnchor}
                                        open={Boolean(menuAnchor)}
                                        onClose={handleCloseMenu}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        <MenuItem onClick={handleOpenEdit}>
                                            <VisibilityIcon fontSize="small" sx={{ mr: 1 }} />
                                            Ver / Editar
                                        </MenuItem>


                                        <MenuItem
                                            onClick={() => {
                                                handleCloseMenu();
                                                // eliminar(menuRowId)
                                            }}
                                            sx={{ color: 'error.main' }}
                                        >
                                            <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
                                            Eliminar
                                        </MenuItem>
                                    </Menu>

                                </Grid>
                            </Grid>

                            <Grid
                                item
                                size={{ xs: 3.2 }}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                            >
                                <InsertDriveFileIcon color="error" fontSize="small" />
                                <Typography variant="body2" noWrap>
                                    XXX - Documento Prueba
                                </Typography>
                            </Grid>

                            <Grid item size={{ xs: 1.6 }}>
                                <Chip size="small" label="San Alfonso" />
                            </Grid>

                            <Grid item size={{ xs: 1.3 }}>
                                <Typography variant="body2">Obligatorio</Typography>
                            </Grid>

                            <Grid item size={{ xs: 1.8 }}>
                                <Typography variant="body2" noWrap>
                                    Firma electrónica
                                </Typography>
                            </Grid>

                            <Grid item size={{ xs: 1.1 }}>
                                <Typography variant="body2">Público</Typography>
                            </Grid>

                            <Grid item size={{ xs: 1.1 }}>
                                <Chip size="small" label="Personas" />
                            </Grid>

                            <Grid item size={{ xs: 1.4 }}>
                                <Chip size="small" color="success" label="Sí" />
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>

            {/* PAGINACIÓN */}
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ px: 2, py: 2 }}
                gap={2}
            >
                <FormControl variant="standard" sx={{ minWidth: 120 }}>
                    <InputLabel>Filas por página</InputLabel>
                    <Select value={25}>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                    </Select>
                </FormControl>

                <Pagination count={3} color="primary" />
            </Grid>

            {editRowId !== null && (
                <EditarDocumento
                    open={Boolean(editRowId)}
                    onClose={() => setEditRowId(null)}
                />

            )}

            <CrearDocumento
                open={openCreate}
                onClose={() => setOpenCreate(false)}
            />



        </Grid>
    );

};
